import { useState } from "react";
import { scrollTo } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const LEGAL = {
  privacy: ["Privacy Policy", "We collect only the details needed to process your enquiry and share them with lending partners with your consent. You may withdraw consent or request deletion of your data at any time by contacting us."],
  terms: ["Terms of Use", "By using this website you agree that we act as a facilitation platform only. Loan approval, pricing and terms are at the sole discretion of the lending partner. Information on this site is indicative and not an offer of credit."],
  consultingTerms: ["Consulting Plans Terms", "Consulting plans are an optional, paid advisory service. They offer guidance only and do not guarantee a loan or approval. Fees are for the consultant's time and are never linked to loan disbursal."],
  refund: ["Refund Policy", "Consulting plan fees are refundable in full if no session has been used, on request within 7 days of purchase. Fees are non-refundable once a session has been logged."],
};

const COLS = [
  ["Company", [["Disclosures", "licences"], ["FAQ", "faq"], ["Contact", "contact"]]],
  ["Product", [["Tools", "tools"], ["Compare rates", "compare"], ["Consulting plans", "plans"], ["Track application", "track"]]],
];

export function Footer({ settings }) {
  const [dlg, setDlg] = useState(null);
  const c = settings?.contact || {};
  return (
    <footer className="bg-[#191c1f] text-white pt-14 pb-28 lg:pb-14">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="bg-white rounded-2xl inline-flex p-2"><img src="/assets/logo.png" alt="Bhartiya Loan Capital" className="h-9" /></div>
            <p className="mt-4 text-sm text-white/60 max-w-xs">Compare loans, check eligibility and apply through our lending partners.</p>
            <p className="mt-3 text-sm text-white/80">{c.phone}<br />{c.email}</p>
          </div>
          {COLS.map(([title, links]) => (
            <div key={title}>
              <h4 className="font-extrabold">{title}</h4>
              <ul className="mt-3 space-y-2 text-sm">
                {links.map(([l, id]) => (
                  <li key={l}><button onClick={() => scrollTo(id)} className="text-white/70 hover:text-white">{l}</button></li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h4 className="font-extrabold">Legal</h4>
            <ul className="mt-3 space-y-2 text-sm">
              {Object.entries(LEGAL).map(([k, v]) => (
                <li key={k}><button data-testid={`footer-legal-${k}`} onClick={() => setDlg(k)} className="text-white/70 hover:text-white">{v[0]}</button></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 text-xs text-white/50 space-y-2">
          <p>Bhartiya Loan Capital is operated by <strong className="text-white/80">Bhartiya Capital Advisory &amp; Consulting LLP</strong>, LLPIN ACZ-6631.</p>
          <p>We are a loan facilitation platform, not a lender. Loan approval, interest rates and terms are decided solely by lending partners. Nothing on this website is an offer or guarantee of credit. Rates shown are indicative.</p>
          <p>© {new Date().getFullYear()} Bhartiya Capital Advisory &amp; Consulting LLP. All rights reserved. · <a href="/admin" className="underline" data-testid="footer-admin-link">Admin</a></p>
        </div>
      </div>

      <Dialog open={!!dlg} onOpenChange={(o) => !o && setDlg(null)}>
        <DialogContent className="max-w-lg rounded-[28px] text-[#191c1f]">
          <DialogHeader><DialogTitle className="text-2xl font-extrabold tracking-[-0.03em]">{dlg && LEGAL[dlg][0]}</DialogTitle></DialogHeader>
          <p className="text-sm leading-relaxed text-[#191c1f]/80" data-testid="footer-legal-text">{dlg && LEGAL[dlg][1]}</p>
        </DialogContent>
      </Dialog>
    </footer>
  );
}
